import React from 'react'
import PropTypes from 'prop-types'
import { Article } from '../components/Article'
import board9 from '../images/board9.jpg'

export function A09({ index }) {
  return (
    <Article
      index={index}
      heading="The entrepreneur goes on to build more services."
      image={board9}
      imageDescription="Alice goes back to brainstorming!"
    />
  )
}

A09.propTypes = {
  index: PropTypes.number.isRequired,
}
